import styled from "styled-components";
import ModalCenterLayout from "../modal/modal.center.layout";
import BackupDateList from "./backup.date.list";
import type { BackupDateContext } from "./backup.date.list";

interface Props {
  context: BackupDateContext;
  onClose: () => void;
}

const DeviceBackupModal = ({ context, onClose }: Props) => (
  <ModalCenterLayout isVisible closedHandler={onClose} size="l">
    <ModalContents
      role="dialog"
      aria-modal="true"
      aria-labelledby="device-backup-title"
    >
      <div className="backup-modal-header">
        <div>
          <h3 id="device-backup-title">백업 보기</h3>
        </div>
        <button type="button" aria-label="백업 목록 닫기" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="path-info">
        <p>
          {context.pcName || context.deviceId} | 경로 :{" "}
          {context.rootDirectoryPath}
        </p>
      </div>
      <BackupDateList context={context} />
    </ModalContents>
  </ModalCenterLayout>
);

const ModalContents = styled.div`
  min-height: 24vh;
  .backup-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 2rem;
    border-bottom: 1px solid #ebebeb;
    background-color: #323232;
    h3 {
      font-size: 14px;
      color: white;
      font-weight: 400;
    }
    button {
      border: 0;
      background: transparent;
      font-size: 2rem;
      cursor: pointer;
      color: white;
    }
  }
  .path-info {
    padding: 2rem;
    p {
      font-size: 14px;
      color: #222;
      font-weight: 400;
      overflow-wrap: anywhere;
    }
  }
`;

export default DeviceBackupModal;
